import {Component, Input, Output, EventEmitter} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';

import {UserService} from '../shared/user.service';
import {ApiService} from '../shared/api.service';

@Component({
    selector: 'login-component',
    templateUrl: 'login.component.html'
})
export class LoginComponent {
    userLogin = new FormControl('', Validators.required);
    userPassword = new FormControl('', Validators.required);
    loading = false;

    private _error = '';
    @Input('error')
    set error(error) {
        this._error = error;
    }
    get error() {
        return this._error;
    }

    @Output() loginChange = new EventEmitter();

    constructor(
        private userService: UserService, 
        private api: ApiService
    ) {}

    submitLogin() {
        if( !this.userLogin.value || !this.userPassword.value ) {
            this.error = 'Please enter username and password.';
            return;
        }
        this.error = '';
        this.loading = true;
        const nonce = this.api.getNonce();
        this.api.removeNonce();
        this.api.doAction('post', 'login', {
            user_login: this.userLogin.value,
            user_password: this.userPassword.value,
            nonce: nonce
        }).subscribe(
            data => {
                this.loading = false;
                this.api.setNonce(data.nonce);
                this.userService.setCurrentUser(data.user);
                this.loginChange.emit(true);
            },
            err => {
                this.loading = false;
                if( !err.error ) {
                    this.error = 'An error occurred. Please try again.';
                } else {
                    this.error = err.error.message;
                }
                this.loginChange.emit(false);
                throw err;
            }
        );
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/login/login.component.ts